<template>
    <div>
        <loading :active.sync="is_loading" :can-cancel="true" :is-full-page="true">
        </loading>
        <!-- Navbar -->
        <Navbar />

        <!-- Sidebar -->
        <SidebarConservation />
        <div id="main" class="main">
            <Breadcrumb :links="links" />
            <section class="section">
                <div class="card">
                    <div class="card-body">
                        <div class="form-group mb-3">
                            <label for="">Tahun</label>
                            <input type="number" class="form-control" v-model="year">
                        </div>
                        <hr>
                        <table class="table table-bordered" id="reg-table">
                            <thead>
                                <tr>
                                    <th rowspan="2">Lokasi</th>
                                    <th rowspan="2">Jenis Tanaman</th>
                                    <th rowspan="2">Unit Wilayah</th>
                                    <th rowspan="2">Wilayah Sungai</th>
                                    <th colspan="2" class="text-center">Koordinat</th>
                                    <th rowspan="2">Jumlah</th>
                                    <th rowspan="2"></th>
                                </tr>
                                <tr>
                                    <th>Longitude</th>
                                    <th>Latitude</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, i) in rows" :key="i">
                                    <td>{{ row.lokasi }}</td>
                                    <td>{{ row.jenis_tanaman }}</td>
                                    <td>{{ row.unit_wilayah }}</td>
                                    <td>{{ row.wilayah_sungai }}</td>
                                    <td>{{ row.lng }}</td>
                                    <td>{{ row.lat }}</td>
                                    <td>{{ row.jumlah }}</td>
                                    <td class="text-center">
                                        <a href="" class="btn btn-sm btn-danger me-2" @click.prevent="removeRow(i)"><i class="fa fa-trash"></i></a>
                                        <a href="" class="btn btn-sm btn-primary" @click.prevent="editRow(i)"><i class="fa fa-pen"></i></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <button class="btn btn-sm btn-success float-end" @click="openAddRowModal">
                            <i class="fa fa-plus"></i> Tambah baris
                        </button>
                        <div class="clearfix"></div>
                        <hr>
                        <button class="btn btn-primary" @click="save"><i class="fa fa-save"></i> simpan</button>
                    </div>
                </div>
            </section>
        </div>
        <b-modal title="Tambah data registrasi konservasi" ref="add_row_modal" :hide-footer="true">
            <div class="form-group mb-3">
                <label for="">Lokasi</label>
                <input type="text" class="form-control" v-model="lokasi">
            </div>
            <div class="form-group mb-3">
                <label for="">Jenis Tanaman</label>
                <input type="text" class="form-control" v-model="jenis_tanaman">
            </div>
            <div class="form-group mb-3">
                <label for="">Unit Wilayah</label>
                <input type="text" class="form-control" v-model="unit_wilayah">
            </div>
            <div class="form-group mb-3">
                <label for="">Wilayah Sungai</label>
                <input type="text" class="form-control" v-model="wilayah_sungai">
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group mb-3">
                        <label for="">Latitude</label>
                        <input type="text" class="form-control" v-model="lat">
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group mb-3">
                        <label for="">Longitude</label>
                        <input type="text" class="form-control" v-model="lng">
                    </div>
                </div>
            </div>
            <div class="form-group mb-3">
                <label for="">Jumlah</label>
                <input type="text" class="form-control" v-model="jumlah">
            </div>
            <button class="btn btn-primary" @click="addRow" v-if="mode === 'add'"><i class="fa fa-plus"></i> Tambah</button>
            <button class="btn btn-primary" @click="updateRow" v-if="mode === 'edit'"><i class="fa fa-plus"></i> Tambah</button>
        </b-modal>
    </div>
</template>

<script>
// import
import Loading from 'vue-loading-overlay'
import Breadcrumb from '../../../components/Breadcrumb.vue'
// Component
import Navbar from '../../../components/Navbar.vue'
import SidebarConservation from '../../../components/SidebarConservation.vue'
import axios from 'axios'; // eslint-disable-line no-unused-vars

export default {
    components: {
        Loading,
        Breadcrumb,
        Navbar,
        SidebarConservation
    },
    data() {
        return {
            is_loading: false,
            links: [
                {url: '/dashboard', text:'Home'}, 
                {url: '/registration', text: 'Registrasi'},
                {url: '#', text: 'Tambah'}
            ],
            lokasi: '',
            jenis_tanaman: '',
            unit_wilayah: '',
            wilayah_sungai: '',
            lng: null,
            lat: null,
            jumlah: 0,
            rows: [],
            year: new Date().getFullYear(),
            mode: 'add',
            current_index: 0
        }
    },
    methods: {
        openAddRowModal(){
            this.mode = 'add';
            this.$refs.add_row_modal.show();
        },
        addRow(){
            this.rows.push({
                lokasi: this.lokasi,
                jenis_tanaman: this.jenis_tanaman,
                unit_wilayah: this.unit_wilayah,
                wilayah_sungai: this.wilayah_sungai,
                lng: this.lng,
                lat: this.lat,
                jumlah: this.jumlah
            });

            this.$refs.add_row_modal.hide();
        },
        removeRow(index){
            this.rows.splice(index, 1);
        },
        editRow(index){
            const data = this.rows[index];

            this.mode = 'edit';
            this.current_index = index;
            this.lokasi = data.lokasi;
            this.jenis_tanaman = data.jenis_tanaman;
            this.unit_wilayah = data.unit_wilayah;
            this.wilayah_sungai = data.wilayah_sungai;
            this.lng = data.lng;
            this.lat = data.lat;
            this.jumlah = data.jumlah;

            this.$refs.add_row_modal.show();
        },
        updateRow(){
            this.rows[this.current_index].lokasi = this.lokasi;
            this.rows[this.current_index].jenis_tanaman = this.jenis_tanaman;
            this.rows[this.current_index].unit_wilayah = this.unit_wilayah;
            this.rows[this.current_index].wilayah_sungai = this.wilayah_sungai;
            this.rows[this.current_index].lat = this.lat;
            this.rows[this.current_index].lng = this.lng;
            this.rows[this.current_index].jumlah = this.jumlah;

            this.$refs.add_row_modal.hide();
        },
        async save(){
            this.is_loading = true;

            try {
                const rows = this.rows.map(row => {
                    row.lng = this.dmsToDd(row.lng);
                    row.lat = this.dmsToDd(row.lat);

                    return {
                        tahun: this.year,
                        ...row
                    }
                }).filter(row => row.jumlah > 0);

                await axios.post(`${this.$endpoints.conservation}/registrations`, {
                    rows
                });

                this.$swal('Success', 'Data registrasi berhasil dimasukan', 'success');
                this.$router.push({
                    name: 'RegistrationIndex'
                });
            } catch (error) {
                console.error(error);
            }

            this.is_loading = false;
        }
    }
}
</script>

<style scoped>
#reg-table input:focus{
    outline: none!important;
    box-shadow: none!important;
}
</style>